export const API_ROOT_REFDATA = process.env.REACT_APP_API_HOST_REFDATA!;
export const API_ROOT_SEARCH = process.env.REACT_APP_API_HOST_SEARCH!;
export const API_ROOT_SVR = process.env.REACT_APP_API_HOST_SVR!;
export const SVR_GUIDANCE_URL = process.env.REACT_APP_SVR_GUIDANCE_URL;
export const API_ROOT_ORGS = process.env.REACT_APP_API_HOST_ORGS!;
export const API_HOST_LINKEDRECORDS = process.env.REACT_APP_API_HOST_LINKEDRECORDS!;